var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-box"},[_c('div',{staticClass:"title"},[_vm._v("공지사항")]),_c('div',{staticClass:"title-s"},[_vm._v("방문예약 시스템 안내사항을 확인하세요.")])])
}]

export { render, staticRenderFns }